import { withTranslation } from "react-i18next";

import { withRouter } from 'react-router';
import React, {Component} from 'react';
import {SNSLoginBtn} from "../components";
import {GOOGLE_ICON} from "../../assets";
import {GoogleAuthProvider, signInWithPopup} from "firebase/auth";
import {auth} from "../../Auth/FirebaseConfig"
// import {loginCallback} from "../../helpers/CommonFunctions";
import SellerUser from "../../Models/SellerUser";

class GoogleFirebaseLogin extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    };

    provider = new GoogleAuthProvider();
    loginCallback = (data)=> {
        console.log("#########", data)
        SellerUser.checkEmail(data).then(res => {
            // const {history} = this.props
            console.log(">>>", res);
            if (parseInt(res.data.status) === 200) {
                if (res.data.payload.user_type_id === 1) {
                    window.localStorage.setItem('info', JSON.stringify(res.data.payload))
                    // window.location.href =
                    this.props.history.push("/buyer-dashboard");
                } else if (res.data.payload.user_type_id === 2) {
                    window.localStorage.setItem('info', JSON.stringify(res.data.payload))
                    // this.props.history.push("/seller-dashboard")
                    this.props.history.push("/seller-dashboard");
                } else if (res.data.payload.user_type_id === 3) {
                    window.localStorage.setItem('info', JSON.stringify(res.data.payload))
                    // this.props.history.push("/affiliator-dashboard")
                    this.props.history.push("/affiliator-dashboard");
                }
            } else {
                alert(this.props.t('0'))
            }
        })
    }
    signInWithGoogle = ()=>{
        signInWithPopup(auth, this.provider)
            .then( (result)=>
                this.loginCallback({email: result.user.email, name: result.user.displayName, user_type: this.props.id})
            ).catch((error)=>{
            console.log("error connecting with google");
        });
    }
    render() {
        return (
            <>
                <SNSLoginBtn logo={GOOGLE_ICON} text={"Connect with Google"} login={this.signInWithGoogle} />
            </>
        );
    }
}

export default withRouter(GoogleFirebaseLogin);


 GoogleFirebaseLogin = withTranslation('src_Components_Login_GoogleFirebaseLogin.js')(GoogleFirebaseLogin);
